import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { UsuarioService } from '../../../services/usuario.service';
import { PedidoConsultaElement } from '../../../interfaces/pedido.consulta';
import { SicoobService } from '../../../services/sicoob';
import { StatusGerarBoleto } from '../../../interfaces/sicoob/erroGerarBoleto';
import { take } from 'rxjs/operators';
import { TokenSicoob } from '../../../interfaces/sicoob/token';

@Component({
  selector: 'app-gerar-boleto-demanda-dialog',
  templateUrl: './gerar-boleto-demanda-dialog.html',
  styleUrls: ['./gerar-boleto-demanda-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class GerarBoletoDemandaDialog implements OnInit {
  uid;

  pedidosGerarBoleto: PedidoConsultaElement[] = [];
  sPedidosGerarBoleto: string = '';
  PDFsBase64: string;

  statusGerarBoleto: StatusGerarBoleto[];
  bGerandoBoleto: boolean;
  bBoletosGerados: boolean;
  bFalhaGerarBoleto: boolean;
  contProgresso: string;
  tokenSicoob: TokenSicoob;

  constructor(
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<GerarBoletoDemandaDialog>,
    private spinner: NgxSpinnerService,
    private usuarioService: UsuarioService,
    private sicoobService: SicoobService,
    @Inject(MAT_DIALOG_DATA) public data: { pedidos: any }
  ) {
    this.uid = localStorage.getItem('uid');
    this.bGerandoBoleto = false;
    this.bBoletosGerados = false;
    this.bFalhaGerarBoleto = false;
    this.statusGerarBoleto = new Array();
    this.contProgresso = '0';
    this.PDFsBase64 = '';
  }

  ngOnInit(): void {
    this.pedidosGerarBoleto = [];
    this.tokenSicoob = {
      access_token: '',
      statusCode: 0,
      dataSolicitacao: null
    };

    const pedidos: PedidoConsultaElement[] = this.data.pedidos;

    for (let i = 0; i < pedidos.length; i++) {
      //Se não houver base64 e a forma de pagamento for Boleto, significa que o pedido deve ser gerado em demanda.
      if (pedidos[i].FormaPagamento === 'Boleto' && (!pedidos[i].PDFbase64 || pedidos[i].PDFbase64?.length < 20)) {
        this.pedidosGerarBoleto.push(pedidos[i]);
        this.sPedidosGerarBoleto = this.sPedidosGerarBoleto + pedidos[i].ID + '; ';
      }
    }

    if (this.pedidosGerarBoleto.length === 0)
      this.sPedidosGerarBoleto = 'Não há pedidos válidos na seleção atual.';
  }

  async confirmarGerarBoletos() {
    if (this.pedidosGerarBoleto.length > 0) {
      this.spinner.show('default');
      this.toastr.warning('Um momento enquanto os boletos são gerados em demanda...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      let auxStatusGerarBoleto: StatusGerarBoleto[] = new Array();
      let auxCont = 0;
      let totalPedidoAnteriorParcelas = 0;
      let bLiberarGerarBoleto: boolean = false; // usado para validar se não há boleto gerado para o pedido informado.
      this.bGerandoBoleto = true;

      for (const pedido of this.pedidosGerarBoleto) {
        await new Promise(async resolve => {
          this.tokenSicoob = await this.sicoobService.retornaTokenValidado(this.tokenSicoob);
          bLiberarGerarBoleto = false;
          this.usuarioService.getPedidoPorNumero(pedido.ID).pipe(take(1)).subscribe((snap: any) => {

            if (snap.payload.exists()) {
              const dados: any = snap.payload.val();
              console.log('Pedido: ' + pedido.ID)
              console.log(dados.IDBoleto)
              bLiberarGerarBoleto = dados.PDFbase64 === undefined ? true : false;
              
              if(pedido.NumeroParcelas === 2){
                bLiberarGerarBoleto = dados.PDFbase64 === undefined && dados.PDFbase64Parcela2 === undefined ? true : false;
              }
              console.log('bLiberarGerarBoleto: ' + bLiberarGerarBoleto)
            }

            resolve(true);
          });
        });

        if (bLiberarGerarBoleto) {
          await new Promise(async resolve => {
            if (pedido.NumeroParcelas === 2) {
              totalPedidoAnteriorParcelas = pedido.Total;
              pedido.Total = Number((pedido.Total / 2).toFixed(2));
              const resp2: StatusGerarBoleto = await this.sicoobService.gerarBoletoPedido(pedido, null, 2, this.tokenSicoob.access_token).then(resp => { return resp }).catch((error) => { return { Pedido: pedido.ID, Erro: `Erro desconhecido: ${error}`, PDFbase64: '', Status: false } });
              console.log('resp2')
              console.log(resp2);
              auxStatusGerarBoleto.push(resp2);

              if ((pedido.Total * 2) > totalPedidoAnteriorParcelas) {
                pedido.Total = totalPedidoAnteriorParcelas - pedido.Total;
              }
            }

            const resp: StatusGerarBoleto = await this.sicoobService.gerarBoletoPedido(pedido, null, 1, this.tokenSicoob.access_token).then(resp => { return resp }).catch((error) => { return { Pedido: pedido.ID, Erro: `Erro desconhecido: ${error}`, PDFbase64: '', Status: false } });

            auxStatusGerarBoleto.push(resp);
            if (resp && !resp?.Status) {
              this.bFalhaGerarBoleto = true;
            }
            auxCont++;
            this.contProgresso = ((auxCont / this.pedidosGerarBoleto.length) * 100).toFixed(0);
            resolve(true);
          }).catch(err => {
            this.finalizarProcesso(err);
            console.log(err);
          });
        } else {
          this.toastr.warning(`Há um boleto em aberto para o pedido: ${pedido.ID}`, 'Status', { progressBar: false, positionClass: 'toast-top-center', });
        }
      };

      this.statusGerarBoleto = auxStatusGerarBoleto;
      this.finalizarProcesso(null);

      console.log('Finalizou boletos em demanda');
    } else
      this.toastr.error("Não há pedidos para gerar boletos", 'Erro');
  }

  finalizarProcesso(err) {
    //Finaliza o processo
    setTimeout(() => {
      this.bBoletosGerados = true;

      if (err !== null || this.statusGerarBoleto.length > 0) {
        const map = {
          Erros: this.statusGerarBoleto,
          Err: err
        }
        this.usuarioService.setLog("Erro na criação de boletos em demanda", map, this.uid);
      } else {
        this.toastr.success('Todos os boletos foram gerados com sucesso!', 'Status', { progressBar: false, positionClass: 'toast-top-center', });
      }

      setTimeout(() => this.spinner.hide('default'), 300);
    }, 1000)
  }

  cancelar() {
    this.dialogRef.close();
  }

  imprimirBoletos() {
    let pdfsBase64: string[] = new Array();
    for (let i = 0; i < this.statusGerarBoleto.length; i++) {
      if (this.statusGerarBoleto[i].Status) {
        pdfsBase64.push(this.statusGerarBoleto[i].PDFbase64);
      }
    }

    this.sicoobService.imprimirBoletos(pdfsBase64, null);
  }

}
